/**
 * Comprehensive list of timezones for user selection
 */
export const TIMEZONES = [
  // US Timezones
  { value: 'America/New_York', label: 'Eastern Time (US & Canada)', offset: 'UTC-5/-4' },
  { value: 'America/Chicago', label: 'Central Time (US & Canada)', offset: 'UTC-6/-5' },
  { value: 'America/Denver', label: 'Mountain Time (US & Canada)', offset: 'UTC-7/-6' },
  { value: 'America/Phoenix', label: 'Arizona (No DST)', offset: 'UTC-7' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (US & Canada)', offset: 'UTC-8/-7' },
  { value: 'America/Anchorage', label: 'Alaska', offset: 'UTC-9/-8' },
  { value: 'Pacific/Honolulu', label: 'Hawaii', offset: 'UTC-10' },

  // Canada
  { value: 'America/St_Johns', label: 'Newfoundland', offset: 'UTC-3:30/-2:30' },
  { value: 'America/Halifax', label: 'Atlantic Time (Canada)', offset: 'UTC-4/-3' },
  { value: 'America/Toronto', label: 'Eastern Time (Canada)', offset: 'UTC-5/-4' },
  { value: 'America/Winnipeg', label: 'Central Time (Canada)', offset: 'UTC-6/-5' },
  { value: 'America/Edmonton', label: 'Mountain Time (Canada)', offset: 'UTC-7/-6' },
  { value: 'America/Vancouver', label: 'Pacific Time (Canada)', offset: 'UTC-8/-7' },

  // Mexico
  { value: 'America/Mexico_City', label: 'Mexico City', offset: 'UTC-6/-5' },
  { value: 'America/Tijuana', label: 'Tijuana', offset: 'UTC-8/-7' },

  // Central & South America
  { value: 'America/Bogota', label: 'Bogota, Lima, Quito', offset: 'UTC-5' },
  { value: 'America/Caracas', label: 'Caracas', offset: 'UTC-4' },
  { value: 'America/Santiago', label: 'Santiago', offset: 'UTC-4/-3' },
  { value: 'America/Sao_Paulo', label: 'São Paulo, Brasilia', offset: 'UTC-3/-2' },
  { value: 'America/Buenos_Aires', label: 'Buenos Aires', offset: 'UTC-3' },

  // Europe
  { value: 'Europe/London', label: 'London, Dublin, Lisbon', offset: 'UTC+0/+1' },
  { value: 'Europe/Paris', label: 'Paris, Berlin, Rome, Madrid', offset: 'UTC+1/+2' },
  { value: 'Europe/Athens', label: 'Athens, Helsinki, Istanbul', offset: 'UTC+2/+3' },
  { value: 'Europe/Moscow', label: 'Moscow, St. Petersburg', offset: 'UTC+3' },

  // Africa
  { value: 'Africa/Cairo', label: 'Cairo', offset: 'UTC+2' },
  { value: 'Africa/Johannesburg', label: 'Johannesburg, Pretoria', offset: 'UTC+2' },
  { value: 'Africa/Lagos', label: 'Lagos, West Central Africa', offset: 'UTC+1' },
  { value: 'Africa/Nairobi', label: 'Nairobi', offset: 'UTC+3' },

  // Middle East
  { value: 'Asia/Dubai', label: 'Dubai, Abu Dhabi', offset: 'UTC+4' },
  { value: 'Asia/Riyadh', label: 'Riyadh, Kuwait', offset: 'UTC+3' },
  { value: 'Asia/Jerusalem', label: 'Jerusalem', offset: 'UTC+2/+3' },
  { value: 'Asia/Tehran', label: 'Tehran', offset: 'UTC+3:30/+4:30' },

  // Asia
  { value: 'Asia/Kolkata', label: 'Mumbai, New Delhi, Kolkata', offset: 'UTC+5:30' },
  { value: 'Asia/Karachi', label: 'Islamabad, Karachi', offset: 'UTC+5' },
  { value: 'Asia/Dhaka', label: 'Dhaka', offset: 'UTC+6' },
  { value: 'Asia/Bangkok', label: 'Bangkok, Hanoi, Jakarta', offset: 'UTC+7' },
  { value: 'Asia/Singapore', label: 'Singapore, Kuala Lumpur', offset: 'UTC+8' },
  { value: 'Asia/Hong_Kong', label: 'Hong Kong, Beijing, Shanghai', offset: 'UTC+8' },
  { value: 'Asia/Taipei', label: 'Taipei', offset: 'UTC+8' },
  { value: 'Asia/Tokyo', label: 'Tokyo, Osaka, Sapporo', offset: 'UTC+9' },
  { value: 'Asia/Seoul', label: 'Seoul', offset: 'UTC+9' },

  // Australia & Pacific
  { value: 'Australia/Sydney', label: 'Sydney, Melbourne, Canberra', offset: 'UTC+10/+11' },
  { value: 'Australia/Brisbane', label: 'Brisbane', offset: 'UTC+10' },
  { value: 'Australia/Adelaide', label: 'Adelaide', offset: 'UTC+9:30/+10:30' },
  { value: 'Australia/Perth', label: 'Perth', offset: 'UTC+8' },
  { value: 'Pacific/Auckland', label: 'Auckland, Wellington', offset: 'UTC+12/+13' },
  { value: 'Pacific/Fiji', label: 'Fiji', offset: 'UTC+12/+13' },
  { value: 'Pacific/Guam', label: 'Guam, Port Moresby', offset: 'UTC+10' },

  // Atlantic
  { value: 'Atlantic/Azores', label: 'Azores', offset: 'UTC-1/+0' },
  { value: 'Atlantic/Cape_Verde', label: 'Cape Verde', offset: 'UTC-1' },

  // UTC
  { value: 'UTC', label: 'UTC (Coordinated Universal Time)', offset: 'UTC+0' },
];

/**
 * Get timezone display name with offset
 */
export const getTimezoneDisplay = (timezoneValue) => {
  const tz = TIMEZONES.find(t => t.value === timezoneValue);
  return tz ? `${tz.label} (${tz.offset})` : timezoneValue;
};
